/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ListUnit_item$ref: FragmentReference;
declare export opaque type ListUnit_item$fragmentType: ListUnit_item$ref;
export type ListUnit_item = {|
  +id: string,
  +name: string,
  +$refType: ListUnit_item$ref,
|};
export type ListUnit_item$data = ListUnit_item;
export type ListUnit_item$key = {
  +$data?: ListUnit_item$data,
  +$fragmentRefs: ListUnit_item$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ListUnit_item",
  "type": "PicklistInterface",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '76a1f6f4027dea2436b549eb6de609a3';
module.exports = node;
